var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('JNav',{attrs:{"title":_vm.$t('newAdd.helpCenter')}}),_c('div',{staticClass:"cont"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.conent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }